// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__20GGm","load8":"style_load8__xK7kj"};